export var IntelligentPhotoCaptureCommonModalType;
(function (IntelligentPhotoCaptureCommonModalType) {
    IntelligentPhotoCaptureCommonModalType["FILE_UPLOAD_ERROR"] = "FILE_UPLOAD_ERROR";
    IntelligentPhotoCaptureCommonModalType["MAX_PHOTO_LIMIT"] = "MAX_PHOTO_LIMIT";
})(IntelligentPhotoCaptureCommonModalType || (IntelligentPhotoCaptureCommonModalType = {}));
//# sourceMappingURL=IntelligentPhotoCaptureCommonModalType.js.map